module.exports = __webpack_public_path__ + "media/img/private-venue/1-f3a686b0695f10645f2778522f8ff451.png";